export default {"src":"/_next/static/media/atd-logo-small.d8066659.svg","height":155,"width":240};